import * as Yup from "yup";
import { getValidationSchema as getValidationSchemaPerson } from "../FormPartialPerson/validationSchema";
import { validationSchemaUsPersonInfo } from "../FormPartialUsPersonInfo/validationSchema";

export const getValidationSchema = (meCountry: string, isUsPerson: boolean) =>
  Yup.object().shape({
    person: getValidationSchemaPerson("Individual", {
      showOwnershipStake: false,
      requireTaxId: true,
      meCountry
    }),
    usPerson: isUsPerson ? validationSchemaUsPersonInfo : Yup.mixed()
  });
